<template>
    <v-dialog
        :value="isOpen"
        max-width="600"
        eager
        transition="slide-y-transition"
        @keydown.esc="onClose(null)"
        @click:outside="onClose(null)"
    >
        <v-card>
            <v-card-title>
                <span class="text-h5">Zamykanie karty stop</span>
            </v-card-title>
            <v-card-text>
                <div class="text-subtitle-1">
                    Zamknięcie karty wiąże się z wystawieniem:
                </div>
            </v-card-text>
            <v-card-text>
                <v-row
                    align="center"
                    justify="space-around"
                >
                    <v-btn
                        class="white--text"
                        color="orange lighten-2"
                        depressed
                        @click="onClose('UJ')"
                    >
                        Uwagi jakościowej
                    </v-btn>
                    <v-btn
                        class="white--text"
                        color="green lighten-2"
                        depressed
                        @click="onClose('RW')"
                    >
                        Reklamacji wewnętrznej
                    </v-btn>
                </v-row>
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Anuluj"
                    @click="onClose(null)"
                >
                    Anuluj
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'CloseStopCardDialog',
    props: {
        isOpen: {
            type: Boolean,
        },
    },
    methods: {
        onClose(value) {
            this.$emit('close', value)
        },
    },
}
</script>